'use client'

import Link from 'next/link'
import { sanitizeHTML } from '@/lib/utils'
import { useScrollAnimation } from '@/hooks/useScrollAnimation'
import FadeIn from '@/components/ui/FadeIn'

interface GetInTouchData {
	anchor_title?: string
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	button?: {
		href: string
		label: string
	}
}

export const fields = [
	'anchor_title',
	'heading.title',
	'text.text',
	'button.href',
	'button.label',
] as const

interface GetInTouchProps {
	data?: GetInTouchData
}

export default function GetInTouch({ data }: GetInTouchProps) {
	const { ref, isVisible } = useScrollAnimation({
		threshold: 0.05,
		rootMargin: '0px',
	})
	const sectionIdBase = data?.anchor_title || 'GetInTouch'
	const sectionId = sectionIdBase
		.replace(/\s+/g, '-')
		.replaceAll(/[^a-zA-Z0-9-_]/g, '-')

	return (
		<section id={sectionId} data-name={data?.anchor_title || 'GetInTouch'} ref={ref} className='GetInTouch py-16 bg-[#212529] max-md:overflow-hidden'>
			<div className='container'>
				<div className='max-w-[980px] mx-auto flex flex-col items-center gap-9'>
					{/* Content */}
					<div className='w-full'>
						{/* Heading */}
						{data?.heading?.title && (
							<FadeIn isVisible={isVisible} delay={0} direction='up'>
								<h2
									className='text-center text-white'
									dangerouslySetInnerHTML={sanitizeHTML(data.heading.title)}
								/>
							</FadeIn>
						)}

						{/* Text */}
						{data?.text?.text && (
							<FadeIn isVisible={isVisible} delay={100} direction='up'>
								<div
									className='text-center text-white grid gap-4'
									dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
								/>
							</FadeIn>
						)}
					</div>

					{/* Button */}
					{data?.button?.href && (
						<FadeIn className='max-md:w-full' isVisible={isVisible} delay={200} direction='up'>
							<Link href={data.button.href} className='btn'>
								{data.button.label}
							</Link>
						</FadeIn>
					)}
				</div>
			</div>
		</section>
	)
}
